import { FC, PropsWithChildren } from 'react'

import { Text } from '@lounge-fe/ui-kit/src/components/Text'

const Title: FC<PropsWithChildren> = ({ children }) => (
  <Text variant="title-five" as="h1">
    {children}
  </Text>
)

export default Title
